'use strict';

(function finalSaleReturnPolicyController(globalScope) {
  const policyRootSelector = '[data-final-sale-return-policy]';
  const defaultPolicySelector = '[data-return-policy-default]';
  const finalSalePolicySelector = '[data-return-policy-final-sale]';
  const variantMetafieldSelector = '[data-variant-final-sale-metafield]';

  function isVariantFinalSale(metafieldsJson, variantId) {
    if (!metafieldsJson || variantId == null) return false;

    try {
      const variantMetafields = JSON.parse(metafieldsJson);
      const selectedMetafield = variantMetafields.find(
        (variantMetafield) => Number(variantMetafield.variant_id) === Number(variantId),
      );

      return selectedMetafield?.metafield_value === 'true';
    } catch (_error) {
      return false;
    }
  }

  function updateReturnPolicy(container, variant) {
    if (!container || !variant) return;

    const policyRoot = container.querySelector(policyRootSelector);
    if (!policyRoot) return;

    const defaultPolicy = policyRoot.querySelector(defaultPolicySelector);
    const finalSalePolicy = policyRoot.querySelector(finalSalePolicySelector);
    if (!defaultPolicy || !finalSalePolicy) return;

    const finalSalePolicyEligible =
      policyRoot.dataset.finalSalePolicyEligible === 'true';
    const metafieldsJson =
      container.querySelector(variantMetafieldSelector)?.textContent;
    const showFinalSalePolicy =
      finalSalePolicyEligible &&
      isVariantFinalSale(metafieldsJson, variant.id);

    defaultPolicy.hidden = showFinalSalePolicy;
    finalSalePolicy.hidden = !showFinalSalePolicy;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      isVariantFinalSale,
      updateReturnPolicy,
    };
  }

  if (!globalScope?.document) return;

  globalScope.document.addEventListener('theme:variant:change', (event) => {
    const container =
      event.target.closest?.('[data-section-type]') || event.target;
    updateReturnPolicy(container, event.detail?.variant);
  });
})(typeof window === 'undefined' ? globalThis : window);
